import { useEffect, useState } from 'react';

interface IMousePosition {
    x: number;
    y: number;
}

const mousePositionInitial: IMousePosition = {
    x: -1000,
    y: -1000,
};

const useMousePosition = () => {
    const [mousePosition, setMousePosition] = useState(mousePositionInitial);

    const handleMouseMove = (event: MouseEvent) => {
        setMousePosition({
            x: event.clientX,
            y: event.clientY,
        });
    };

    useEffect(() => {
        window.addEventListener('mousemove', handleMouseMove);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return { mousePosition };
};

export default useMousePosition;
